import { render, staticRenderFns } from "./FamiliesView.vue?vue&type=template&id=16572f02&scoped=true"
import script from "./FamiliesView.vue?vue&type=script&lang=js"
export * from "./FamiliesView.vue?vue&type=script&lang=js"
import style0 from "./FamiliesView.vue?vue&type=style&index=0&id=16572f02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16572f02",
  null
  
)

export default component.exports